import React, { useEffect, useState } from "react";

import {
    TextField,
    FormControlLabel,
    Checkbox,
    Radio,
    FormControl,
    FormLabel,
    RadioGroup,
} from '@material-ui/core';

import ReCAPTCHA from "react-google-recaptcha";

import validateForm from "../../Forms/functions";
import Alert from "../../Forms/Alert";

import Loading from "../../../Layouts/Loading";
import { Autocomplete } from "@material-ui/lab";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";

const attrsClass = {
    'name': 'str',
    'email': 'email',
    'contact': 'phone',
    'policy': 'bool',
    'recaptcha': 'str',
    'message': 'str',
}

const attrsName = {
    'name': 'Nome',
    'email': 'Email',
    'contact': 'Contacto',
    'policy': 'Política de privacidade',
    'recaptcha': 'ReCaptcha',
    'message': 'Mensagem'
}

const ContactForm = ({ propertyID }) => {

    const [sent, setSent] = useState(false);

    // Form
    const [form, setForm] = useState({
        'name': null,
        'email': null,
        'contact': null,
        'message': null,
        'policy': false,
        'recaptcha': null,
    });


    // Loading (when submitting form)
    const [loading, setLoading] = useState(!propertyID);

    const [types, setTypes] = useState([]);
    const [counties, setCounties] = useState([]);
    useEffect(() => {
        if (propertyID) return;

        fetch(process.env.REACT_APP_API + "/realstate/types/?all=true")
            .then(res => res.json())
            .then(json => {
                // Set intervals
                setTypes(json);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });

        fetch(process.env.REACT_APP_API + "/realstate/counties/?all=true")
            .then(res => res.json())
            .then(json => {
                // Set intervals
                setCounties(json);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [])

    // Form change
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        console.log("handleChange", name, value, type, checked);

        setForm(f => ({
            ...f,
            [name]: type === "checkbox" ? checked : value,
        }));
    }

    const recaptcha = (value) => {
        setForm(f => ({
            ...f,
            'recaptcha': value
        }));
    }

    // Form submit and validation
    const [alert, setAlert] = useState([]);
    const [showAlert, setShowAlert] = useState(false);

    const submit = () => {
        console.log("submit", form);
        if (!propertyID) {
            delete attrsClass.message;

            attrsClass['clientType'] = "str";
            attrsClass['propertyType'] = "list";
            attrsClass['financing'] = "str";
            attrsClass['counties'] = "list";
            attrsClass['investment'] = "str";
            attrsClass['selling'] = "str";

            attrsName['clientType'] = "Procuro...";
            attrsName['propertyType'] = "Tipos de propriedade";
            attrsName['financing'] = "Tem financiamento?";
            attrsName['counties'] = "Zonas";
            attrsName['investment'] = "Valor";
            attrsName['selling'] = "Precisa de vender?";

            if (form.selling == "true") {
                attrsClass['sellingType'] = "str";
                attrsClass['sellingCounties'] = "str";
                attrsClass['sellingValue'] = "str";

                attrsName['sellingType'] = "Venda: Tipo de propriedade";
                attrsName['sellingCounties'] = "Venda: Zona";
                attrsName['sellingValue'] = "Venda: Valor";
            } else {
                delete attrsClass.sellingType;
                delete attrsClass.sellingCounties;
                delete attrsClass.sellingValue;
            }
        }

        // Validate form and show alert if error
        let errors = validateForm(form, attrsClass, attrsName);
        setAlert(errors);
        if (errors.length > 0) { setShowAlert(true); return; }

        submitContact();
    }

    const submitContact = () => {
        // Enable loading
        setLoading(true);

        let f = {...form};
        Object.keys(f).forEach(k => { // Convert checkbox attributes to list
            if (k.includes(":")) {
                let key = k.split(":")[0];
                if (!(key in f)) f[key] = [];
                if (f[k] === true) f[key].push(k.split(":")[1]);
                delete f[k];
            }
        });

        // Submit form to API
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...f,
                property: propertyID
            })
        };

        fetch(process.env.REACT_APP_API + '/crm/contacts/', requestOptions)
            .then(response => response.json())
            .then(data => {
                // Show feedback
                if ('error' in data) {
                    setAlert(data['error']);
                } else if ('client' in data) {
                    setAlert([]);
                    // Reset form
                    setForm({
                        'name': "",
                        'email': "",
                        'contact': "",
                        'message': "",
                        'policy': false,
                        'recaptcha': null,
                    });
                } else {
                    setAlert('Ocorreu um erro. Tente novamente.');
                }
                // Show alert (for success or not)
                if (alert && alert.length===0)  {
                    setSent(true);
                } else {
                    setShowAlert(true);
                }
                // Disable loading 
                setLoading(false);
            })
            .catch((error) => {
                // Give user feedback
                setAlert('Ocorreu um erro na submissão do formulário. Tente novamente.');
                // Show alert (for success or not)
                setShowAlert(true);
                // Disable loading 
                setLoading(false);
            });
    }

    // Autocomplete for features
    const icon = <CheckBoxOutlineBlank fontSize="small" />;
    const checkedIcon = <CheckBox fontSize="small" />;

    return (
        <div className="bg-white p-4">
            {!sent && propertyID && <h5 class="font-weight-bold">Está interessado?</h5>}
            {!sent &&  propertyID && <h6>Contacte-nos!</h6>}

            {
                sent &&
                <>
                    <h5 class="font-weight-bold">Obrigado pelo seu contacto!</h5>
                    <p>
                        Iremos analisar o seu pedido e entraremos em contacto tão breve quanto possível.
                    </p>
                </> 
            }

            {
                loading 
                    ?
                    <Loading />
                    : !sent ?
                    <>

                        <TextField
                            id="contact_name"
                            label="Nome"
                            type="text"
                            className="col-12 my-2"
                            name="name"
                            onChange={handleChange}
                            value={form.name}
                        />

                        <TextField
                            id="contact_email"
                            label="Email"
                            type="email"
                            className="my-2 col-12"
                            name="email"
                            onChange={handleChange}
                            value={form.email}
                        />

                        <TextField
                            id="contact_contact"
                            label="Contacto"
                            type="text"
                            className="my-2 col-12"
                            name="contact"
                            onChange={handleChange}
                            value={form.contact}
                        />

                        {
                            !propertyID && <div className="my-3">
                                <FormControl component="fieldset" className="my-2 mr-2">
                                    <FormLabel component="legend">Procuro...</FormLabel>
                                    <RadioGroup row name="clientType" value={form.clientType} onChange={handleChange}>
                                        <FormControlLabel value="C" control={<Radio color="primary" />} label="Comprar" />
                                        <FormControlLabel value="A" control={<Radio color="primary" />} label="Arrendar" />
                                    </RadioGroup>
                                </FormControl>

                                <FormControl component="fieldset" className="my-2">
                                    <FormLabel component="legend">Tipos de propriedade</FormLabel>
                                    <RadioGroup row name="propertyTypes">
                                        {
                                            types.map(t =>
                                                <FormControlLabel
                                                    value={t.id}
                                                    control={<Checkbox color="primary"
                                                        value={t.id}
                                                        name={"propertyType:" + t.id}
                                                        onChange={handleChange}
                                                    />} label={t.name} />
                                            )
                                        }
                                    </RadioGroup>
                                </FormControl>

                                <FormControl component="fieldset" className="my-2 mr-2">
                                    <FormLabel component="legend">Tem financiamento?</FormLabel>
                                    <RadioGroup row name="financing" value={form.financing} onChange={handleChange}>
                                        <FormControlLabel value="true" control={<Radio color="primary" />} label="Sim" />
                                        <FormControlLabel value="false" control={<Radio color="primary" />} label="Não" />
                                    </RadioGroup>
                                </FormControl>

                                <TextField
                                    className="col-12 my-2"
                                    name="bedrooms"
                                    label="Número de quartos"
                                    value={form.bedrooms}
                                    onChange={handleChange}
                                    type="number"
                                />

                                <Autocomplete
                                    className="my-2"
                                    multiple
                                    id="id"
                                    options={counties}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.name}
                                    groupBy={(option) => option.district.name}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                            />
                                            {option.name}
                                        </React.Fragment>
                                    )}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Zonas" placeholder="" />
                                    )}
                                    onChange={(event, value) => handleChange({ target: { name: "counties", value: value.map(v => v.id) } })}
                                />

                                <TextField
                                    className="col-12 my-2"
                                    name="investment"
                                    label="Valor"
                                    value={form.investment}
                                    onChange={handleChange}
                                    type="number"
                                />

                                <FormControl component="fieldset" className="mt-4 my-2 mr-2">
                                    <FormLabel component="legend">Precisa de vender?</FormLabel>
                                    <RadioGroup row name="selling" value={form.selling} onChange={handleChange}>
                                        <FormControlLabel value="true" control={<Radio color="primary" />} label="Sim" />
                                        <FormControlLabel value="false" control={<Radio color="primary" />} label="Não" />
                                    </RadioGroup>
                                </FormControl>

                                {
                                    form.selling && form.selling == "true" &&
                                    <div className="">
                                        <FormControl component="fieldset" className="my-2">
                                            <FormLabel component="legend">Tipo de propriedade</FormLabel>
                                            <RadioGroup row name="sellingType" value={form.sellingType ? form.sellingType : ""} onChange={handleChange}>
                                                {
                                                    types.map(t =>
                                                        <FormControlLabel value={t.id.toString()} control={<Radio color="primary" />} label={t.name} />
                                                    )
                                                }
                                            </RadioGroup>
                                        </FormControl>

                                        <Autocomplete
                                            className="my-2"
                                            id="id"
                                            options={counties}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) => option.name}
                                            groupBy={(option) => option.district.name}
                                            renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                    {option.name}
                                                </React.Fragment>
                                            )}
                                            style={{ width: "100%" }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Zona" placeholder="" />
                                            )}
                                            onChange={(event, value) => handleChange({ target: { name: "sellingCounties", value: value ? value.id : value } })}
                                        />

                                        <TextField
                                            className="col-12 my-2"
                                            name="sellingValue"
                                            label="Valor"
                                            value={form.sellingValue}
                                            onChange={handleChange}
                                            type="number"
                                        />
                                    </div>
                                }


                            </div>
                        }

                        <TextField
                            id="contact_message"
                            label={propertyID ? "Mensagem" : "Comentário"}
                            multiline
                            rows={4}
                            defaultValue=""
                            name="message"
                            className="my-2 col-12"
                            onChange={handleChange}
                            value={form.message}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={form.policy}
                                    onChange={handleChange}
                                    name="policy"
                                    color="primary"
                                />
                            }
                            label="Aceito a política de privacidade."
                            className="my-2"
                        />

                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA}
                            onChange={recaptcha}
                        />

                        <button
                            class="btn btn-primary mt-3 col-12"
                            onClick={() => submit()}
                        >
                            Submeter
                        </button>
                    </>
                    : <></>
            }


            {
                // Feedback
            }

            <Alert
                alert={alert}
                show={showAlert}
                setShow={setShowAlert}
            />

        </div>
    );
}

export default ContactForm;
